import React from "react";

import { IArticleProps } from "@advice/pages/article/Article";

/**
 * provides article content as a wrapper to components.
 * @example
 * <ArticleContentProvider>
 *     <MyComponent />
 * </ArticleContentProvider>
 * Then inside your component:
 * @example
 * import { ArticleContent } from "@advice/components/shared/ArticleContent";
 * export const MyComponent: React.FC = () => {
 *     const ArticleContent = useContext(ArticleContent);
 *     console.log("title", ArticleContent.title);
 * }
 */
const ArticleContent = React.createContext(({} as any) as IArticleProps);

const ArticleContentProvider: React.FC<IArticleProps> = props => {
    return <ArticleContent.Provider value={props}>{props.children}</ArticleContent.Provider>;
};

export { ArticleContent, ArticleContentProvider };
